import React, { FC, useCallback } from 'react';
import { FieldWrapper, DatePicker } from '@td-client-frontend/common';
import { format, isValid, addDays } from 'date-fns';
import { ActivityDateRangeObject, ActivitySearchChangeObject } from '../../../@types/Audit';

interface ActivityDateRange {
  dateRangeData: ActivityDateRangeObject;
  onChange: (dateRangeData: ActivityDateRangeObject) => void;
  onSelect: (changeObject: ActivitySearchChangeObject) => void;
  dateRange?: number;
}

export const ActivityDateRange: FC<ActivityDateRange> = ({ dateRangeData: { from, to }, onChange, onSelect }) => {
  const handleStartDate = useCallback(
    (date: Date) => {
      onChange({ from: date, to });
      if (isValid(date)) {
        onSelect({ key: 'from', value: format(date, 'MM/dd/yyyy') });
      }
    },
    [onChange, onSelect, to]
  );

  const handleEndDate = useCallback(
    (date: Date) => {
      onChange({ from, to: date });
      if (isValid(date)) {
        onSelect({ key: 'to', value: format(date, 'MM/dd/yyyy') });
      }
    },
    [from, onChange, onSelect]
  );

  return (
    <div className="flex space-x-4 min-w-24 items-end">
      <FieldWrapper label="Date range">
        <div className="flex flex-row space-x-4">
          <DatePicker
            name="from"
            placeholder="MM/DD/YYYY"
            onChange={handleStartDate}
            selected={from}
            selectsStart
            closeOnScroll
            startDate={from}
            endDate={to}
            maxDate={to}
            wrapperClasses="flex flex-col w-full"
            fieldLabelClasses="hidden"
            errorClassName={isValid(from) ? 'hidden' : undefined}
            isError={!isValid(from)}
            error={!isValid(from) ? 'Date should be valid' : undefined}
          />
          <DatePicker
            name="to"
            placeholder="MM/DD/YYYY"
            onChange={handleEndDate}
            selected={to}
            selectsEnd
            closeOnScroll
            startDate={from}
            endDate={to}
            minDate={from}
            maxDate={addDays(new Date(), 1)}
            wrapperClasses="flex flex-col w-full"
            fieldLabelClasses="hidden"
            errorClassName={isValid(to) ? 'hidden' : undefined}
            isError={!isValid(to)}
            error={!isValid(to) ? 'Date should be valid' : undefined}
          />
        </div>
      </FieldWrapper>
    </div>
  );
};
